/**
 * br-video-hero — accessible media-card video controls.
 */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setup = (section) => {
    if (section.dataset.brVideoHeroReady === 'true') return;
    section.dataset.brVideoHeroReady = 'true';

    const video = section.querySelector('.br-video-hero__video');
    const toggle = section.querySelector('[data-br-video-hero-video-toggle]');
    if (!toggle) return;

    const pauseIcon = toggle.querySelector('[data-br-video-hero-pause]');
    const playIcon = toggle.querySelector('[data-br-video-hero-play]');
    const playbackMode = section.dataset.videoPlaybackMode;
    const clickWithSound = playbackMode === 'click_with_sound';
    const modalWithSound = playbackMode === 'modal_with_sound';
    if (!video && !modalWithSound) return;

    const modal = modalWithSound
      ? document.getElementById(toggle.getAttribute('aria-controls'))
      : null;
    const modalVideo = modal?.querySelector('.br-video-hero__modal-video');
    const modalClose = modal?.querySelector('[data-br-video-hero-modal-close]');
    const labels = {
      play: toggle.dataset.labelPlay,
      pause: toggle.dataset.labelPause,
    };
    let userPaused = false;

    const syncControl = () => {
      if (modalWithSound) {
        section.classList.remove('br-video-hero--video-playing');
        pauseIcon.hidden = true;
        playIcon.hidden = false;
        toggle.setAttribute('aria-pressed', 'false');

        if (labels.play) {
          toggle.setAttribute('aria-label', labels.play);
        }

        return;
      }

      const paused = video.paused;
      section.classList.toggle('br-video-hero--video-playing', !paused && !modalWithSound);
      pauseIcon.hidden = paused;
      playIcon.hidden = !paused;
      toggle.setAttribute('aria-pressed', paused ? 'false' : 'true');

      if (labels.play && labels.pause) {
        toggle.setAttribute('aria-label', paused ? labels.play : labels.pause);
      }
    };

    const syncPlayback = () => {
      if (modalWithSound) {
        if (video) {
          video.muted = true;
          video.controls = false;

          if (reducedMotion.matches) {
            video.pause();
          } else {
            video.play().catch(() => {});
          }
        }

        syncControl();
        return;
      }

      if (clickWithSound) {
        video.muted = false;
        video.controls = true;
        syncControl();
        return;
      }

      if (reducedMotion.matches || userPaused) {
        video.pause();
      } else {
        video.play().catch(() => {
          syncControl();
        });
      }

      syncControl();
    };

    const closeModal = () => {
      if (!modal) return;

      modal.close();
    };

    const openModal = () => {
      if (!modal || !modalVideo) return;

      video?.pause();
      modal.showModal();
      modalVideo.muted = false;
      modalVideo.controls = true;
      modalVideo.currentTime = video?.currentTime || 0;
      modalVideo.play().catch(() => {});
    };

    toggle.addEventListener('click', () => {
      if (modalWithSound) {
        openModal();
        return;
      }

      if (video.paused) {
        userPaused = false;
        if (clickWithSound) {
          video.muted = false;
          video.controls = true;
        }
        video.play().catch(() => {
          syncControl();
        });
      } else {
        userPaused = true;
        video.pause();
      }
    });

    video?.addEventListener('play', syncControl);
    video?.addEventListener('pause', syncControl);
    modalClose?.addEventListener('click', closeModal);
    modal?.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    modal?.addEventListener('close', () => {
      if (modalVideo) {
        modalVideo.pause();
      }

      syncPlayback();
    });
    reducedMotion.addEventListener('change', syncPlayback);
    syncPlayback();
  };

  document.querySelectorAll('[data-br-video-hero]').forEach(setup);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-br-video-hero]').forEach(setup);
  });
})();
